const MUTUAL_TRANSLATIONS = {
  // time period
  PERIOD_SELECT_THIS_WEEK: 'This week',
  PERIOD_SELECT_LAST_7: 'Last seven days',
  PERIOD_SELECT_THIS_MONTH: 'This month',
  PERIOD_SELECT_LAST_3_MONTH: 'Last three months',
  PERIOD_SELECT_LAST_YEAR: 'Last year',
  PERIOD_SELECT_CHOOSE_CALENDAR: 'Pick from calendar',

  // conversation statuses
  CLOSED_CONVERSATION: 'Closed conversations',
  ACCEPTED_CONVERSATION: 'Accepted conversations',
  OPENED_CONVERSATION: 'Pending conversations',
  CLOSED_AGENT_CONVERSATION: 'Unanswered conversations',
  DENIED_CONVERSATION: 'Denied conversations',

  STATISTICS_DATE_PICKER_PLACEHOLDER: 'Filter by date',
};

export default MUTUAL_TRANSLATIONS;
